import * as trace from 'owa-trace';
import isPerformanceResourceSupported from './IsPerformanceResourceSupported';
import { clearPerfMarkers } from './clearPerfMarkers';
import { getLastMarkedMeasure } from './getLastMarkedMeasure';

/**
 * Measures the timing from start to end and saves the result int the performance entries by measureName provided in the params
 * See https://w3c.github.io/user-timing/#dom-performance-measure for more info.
 * @param measureName name to be used when logging in perf entries
 * @param start start of the measure
 * @param end undefined by default, measures from the start of the
 */

interface SafePerformanceMeasureTypes {
    measureName: string;
    start: string;
    end?: string;
    clearMarkers?: boolean;
}

export const safePerformanceMeasure = ({
    measureName,
    start,
    end,
    clearMarkers,
}: SafePerformanceMeasureTypes): PerformanceEntry | null => {
    try {
        if (isPerformanceResourceSupported) {
            performance.measure(measureName, start, end);

            if (clearMarkers) {
                clearPerfMarkers([start, end]);
            }

            return getLastMarkedMeasure(measureName);
        }
    } catch (error) {
        // start marker was not found: trace error
        trace.errorThatWillCauseAlert('MeasurePerfMarkersFailed: Failed to measure perf', error);
    }

    return null;
};
